import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { VariablesGlobalState, defaultVariablesGlobalState } from './types';

export const variablesSlice = createSlice({
  name: 'variables',
  initialState: defaultVariablesGlobalState,
  reducers: {
    lastPatientDuplicateDateChanged: (
      state,
      action: PayloadAction<number>,
    ): VariablesGlobalState => {
      return {
        ...state,
        lastPatientDuplicateDate: action.payload,
      };
    },
  },
});

export const VariablesActions = variablesSlice.actions;
